import { Avatar } from '@getsynapse/design-system';
import get from 'lodash/get';
import intl from 'react-intl-universal';
import { useMemo } from 'react';
import { AvatarUser } from 'utils/customTypes';
import { isUserStatusDisabled } from 'utils/functions';
import { DeletedUser } from './DeletedUser/DeletedUser';

interface Props {
  className?: string;
  size?: 'small' | 'medium' | 'large';
  user?: AvatarUser;
  showTooltip?: boolean;
}

const UserAvatar = ({ className, size, user, showTooltip = true }: Props) => {
  const fullName = useMemo(() => {
    const firstName = user?.data?.firstName;
    const lastName = user?.data?.lastName;
    if (!firstName && !lastName) return '';
    return `${firstName || ''} ${lastName || ''}`.trim();
  }, [user]);

  if (!user) {
    return <DeletedUser className={className} size={size} />;
  }

  const getInitials = () => {
    const displayInitial = `${get(user, 'data.firstName[0]', '')}${get(
      user,
      'data.lastName[0]',
      ''
    )}`;
    if (!displayInitial) {
      return get(user, 'data.email[0]', '');
    }
    return displayInitial;
  };

  const isDisabled = isUserStatusDisabled(user?.status);

  return (
    <Avatar
      className={className}
      imageSrc={get(user, 'avatar_url')}
      initial={getInitials()}
      name={fullName}
      size={size}
      disabled={isDisabled}
      showTooltip={showTooltip}
      // Avatar falls back to a hardcoded English badge without this, and only
      // shows it when `disabled` - which this atom derives, so no caller can.
      deactivatedText={intl.get('DEACTIVATED')}
    />
  );
};

export default UserAvatar;
